export default __webpack_public_path__ + "static/media/regulatory--wear-seat-belt--g3.4cdb1888.png";